import React, {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import MoleculeNotification, {
  BRDS_SIZE as moleculeNotificationBorderRadiusSize
} from '@s-ui/react-molecule-notification'
import ListRelatedAds, {listRelatedAdsContactTypes, listRelatedAdsLeadTargets} from '@adv-mt/mt-list-related-ads'

import {DEFAULT_MODAL_DESCRIPTION} from './config.js'

const MESSAGE_TEST_ID = 'modal-related-ads-message'

const isContactedAd = ({isAlreadyContacted}) => Boolean(isAlreadyContacted)

const ModalContent = ({
  ads,
  contactType: selectedContactType,
  hasClickableCards,
  hasCriteoEvents = false,
  leadTarget = listRelatedAdsLeadTargets.relatedVehicle,
  modalDescription,
  onClickRelatedAd = () => {},
  onRelatedAdContact,
  showInitialNotification = true
}) => {
  const {i18n, domain} = useContext(Context)

  const config = domain.get('config')
  const appName = config.get('APP_NAME')

  const [showNotification, setShowNotification] = useState(showInitialNotification)

  const hasContactedAds = ads.some(isContactedAd)

  const NOTIFICATION_PROPS = {
    autoClose: 'short',
    position: 'relative',
    roundedCorners: moleculeNotificationBorderRadiusSize.medium,
    showCloseButton: false,
    type: 'success'
  }

  const description = modalDescription || DEFAULT_MODAL_DESCRIPTION[appName]

  const _closeNotification = () => setShowNotification(false)

  const _hasAdBeenContacted = adId => {
    const contactedAd = ads.find(({id}) => id === adId)
    const hasBeenContacted = Boolean(contactedAd.isAlreadyContacted)
    return hasBeenContacted
  }

  const _onContact = ({id, price, vehicleHistory, highlightType, leadData}) => {
    const hasBeenContacted = _hasAdBeenContacted(id)

    if (hasBeenContacted) return
    onRelatedAdContact({
      contactType: selectedContactType,
      highlightType,
      id,
      leadData,
      price,
      vehicleHistory
    })
  }

  const handleClickRelatedAd = ({ad, position}) => onClickRelatedAd({ad, position})

  return (
    <>
      {!hasContactedAds && (
        <MoleculeNotification {...NOTIFICATION_PROPS} show={showNotification} onClose={_closeNotification}>
          <span className="mt-ModalRelatedAds-notification">{i18n.t(`COMMON.MODAL_RELATED_ADS_NOTIFICATION`)}</span>
        </MoleculeNotification>
      )}
      <p className="mt-ModalRelatedAds-message" data-testid={MESSAGE_TEST_ID}>
        {i18n.t(description)}
      </p>
      <ListRelatedAds
        ads={ads}
        contactType={selectedContactType}
        hasClickableCards={hasClickableCards}
        hasCriteoEvents={hasCriteoEvents}
        leadTarget={leadTarget}
        maxItems={6}
        onContactAd={_onContact}
        onClickRelatedAd={handleClickRelatedAd}
      />
    </>
  )
}

ModalContent.propTypes = {
  ads: PropTypes.array,
  contactType: PropTypes.oneOf(Object.values(listRelatedAdsContactTypes)),
  hasClickableCards: PropTypes.bool,
  hasCriteoEvents: PropTypes.bool,
  leadTarget: PropTypes.oneOf(Object.values(listRelatedAdsLeadTargets)),
  modalDescription: PropTypes.string,
  onClickRelatedAd: PropTypes.func,
  onRelatedAdContact: PropTypes.func,
  showInitialNotification: PropTypes.bool
}

export {listRelatedAdsLeadTargets as modalRelatedAdsLeadTargets}

export default ModalContent
